'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentAlipayAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M78.9825 25.1452L79 25.126H76.2351L74.4892 31.1783H74.3965L72.3919 25.126H69.1062L73.0595 35.1142L71.4079 38.1587V38.2321H73.9876L78.9825 25.1452Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M48.331 25.126H45.3984V35.0775H48.331V25.126Z", fill: "black" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M68.5294 32.5889V28.431C68.5294 26.166 67.1924 24.9216 64.8348 24.9216C63.33 24.9216 62.2918 25.182 60.3973 25.757L60.9164 28.0413C62.6431 27.2618 63.4034 26.928 64.2021 26.928C65.1668 26.928 65.595 27.6149 65.595 28.674V28.7474C62.2342 29.3783 61.1943 29.7313 60.5459 30.3815C60.0635 30.8639 59.859 31.5507 59.859 32.3494C59.859 34.2614 61.3446 35.2821 62.7358 35.2821C63.7756 35.2821 64.611 34.8923 65.7436 34.0377L65.9481 35.0776H68.8807L68.5294 32.5889ZM65.5968 32.664C64.8173 33.0904 64.3716 33.2582 63.8525 33.2582C63.1465 33.2582 62.7008 32.7933 62.7008 32.0523C62.7008 31.7744 62.7567 31.4948 62.9787 31.2728C63.3317 30.9198 64.0186 30.6594 65.5968 30.2889V32.664Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M55.6277 24.9216C54.5512 24.9216 53.7157 25.3306 52.7685 26.1101V25.1261H49.8358V38.2322H52.7685V34.9832C53.326 35.1318 53.8451 35.2069 54.476 35.2069C57.0941 35.2069 59.4517 33.2757 59.4517 29.8414C59.4517 26.7602 57.7442 24.9216 55.6277 24.9216ZM53.7699 33.3683C53.4361 33.3683 53.1198 33.3316 52.7667 33.2198V27.8368C53.3802 27.4104 53.88 27.2059 54.511 27.2059C55.6068 27.2059 56.4789 28.078 56.4789 29.9358C56.4806 32.311 55.1996 33.3683 53.7699 33.3683Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M20.5389 20H7.96413C6.32652 20 5 21.3388 5 22.9886V35.67C5 37.3199 6.32652 38.6586 7.96413 38.6586H20.5389C22.1765 38.6586 23.5013 37.3199 23.5013 35.67V22.9886C23.5031 21.337 22.1765 20 20.5389 20Z",
          fill: "#44A0E3"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M20.2331 31.7167C19.4938 31.4668 18.4994 31.084 17.3931 30.6803C18.0572 29.5146 18.5885 28.1881 18.9381 26.7462H15.2906V25.4214H19.7577V24.6821H15.2906V22.473H13.4677C13.1479 22.473 13.1479 22.7911 13.1479 22.7911V24.6804H8.63003V25.4197H13.1479V26.7444H9.41651V27.4837H16.652C16.3881 28.403 16.0316 29.2681 15.6104 30.0529C13.2632 29.2716 10.757 28.639 9.18406 29.0287C8.17738 29.2786 7.52897 29.7243 7.14797 30.1927C5.40026 32.3371 6.65337 35.5949 10.3445 35.5949C12.5274 35.5949 14.6299 34.368 16.2588 32.3459C18.6899 33.5238 23.5013 35.5477 23.5013 35.5477V32.6639C23.5031 32.6639 22.8984 32.615 20.2331 31.7167ZM10.0002 34.3487C7.12176 34.3487 6.27062 32.0627 7.69326 30.8114C8.16864 30.3884 9.0355 30.1822 9.4969 30.1368C11.2062 29.9672 12.7896 30.6244 14.6579 31.5437C13.3454 33.2704 11.6728 34.3487 10.0002 34.3487Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M35.3176 21.9889H31.3817L26.9827 35.0775H29.6934L30.4362 32.5154H35.0956L35.8017 35.0775H39.2727L35.3176 21.9889ZM31.0479 30.3797L32.7921 24.3466H32.8655L34.5171 30.3797H31.0479Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M43.3921 21.5239H40.4594V35.0757H43.3921V21.5239Z", fill: "black" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M45.1747 22.7316C45.1747 23.6963 45.8808 24.3465 46.8647 24.3465C47.8487 24.3465 48.5548 23.6963 48.5548 22.7316C48.5548 21.7843 47.8487 21.1167 46.8647 21.1167C45.8808 21.1167 45.1747 21.7843 45.1747 22.7316Z",
          fill: "#44A0E3"
        }
      )
    ]
  }
);
const VpPaymentAlipayAsset = forwardRef(PaymentAlipayAsset);

export { VpPaymentAlipayAsset as default };
